module.exports = __webpack_public_path__ + "static/Header-32914015ef625514897dfc9540b13aed.png";